import { render, staticRenderFns } from "./column-select.vue?vue&type=template&id=2ee419a6&scoped=true&"
import script from "./column-select.vue?vue&type=script&lang=js&"
export * from "./column-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee419a6",
  null
  
)

export default component.exports